<template>
  <footer class="footer">
    <!-- For IF you want ehi products and services on your next project -->
    <section class="container section col-12">
      <div class="container-content text-center">
        <h3>IF YOU WANT EHI PRODUCTS AND SERVICES ON YOUR NEXT PROJECT,</h3>
        <h4>We have experts for that!</h4>
        <div class="paraContact d-flex flex-column align-items-center">
          <div class="paragraph mt-3">
            <p>
              Schedule a presentation to learn about our services and products.
              Our team will meet with you and align with your ideas and
              expectations. A plant tour completes the experience to reveal why
              Easyhomes, Inc. has been in the industry for 15 years.
            </p>
          </div>
          <div class="contact-us-btn my-4">
            <button>
              <router-link to="/contact-us">CONTACT US TODAY!</router-link>
            </button>
          </div>
        </div>
      </div>
    </section>
    <!-- Main Footer -->
    <!-- New Footer -->
    <div class="container-fluid mx-auto px-5 mt-4 text-left">
      <div class="row">
        <!-- About Us -->
        <div class="col-md-4">
          <h5 class="text-white text-uppercase mb-3 footer-title-weight">
            About Us
          </h5>
          <hr class="hr-line mb-4" />
          <p class="text-white footer-para-weight">
            Easyhomes broke ground in 2007. Since then, the company has
            designed, tested, and installed 150,000+ linear meters of precast
            concrete fences from Pangasinan to Iloilo. We have served clients
            such as Alveo/Ayala, Aboitizland, SM Investments, Landco, PA
            Builders, and CENQ.
          </p>

          <div class="my-3">
            <!-- Facebook btn -->
            <a target="_blank" rel="noopener" href="https://www.facebook.com/easyhomesinc.ph"
              class="btn btn-icon-only btn-round btn-lg border border-primary" data-toggle="tooltip"
              data-original-title="Like us">
              <i class="fa fa-facebook-f"></i>
            </a>
            <!-- Indeed btn -->
            <a target="_blank" rel="noopener" href="https://www.linkedin.com/company/easyhomes-incorporated"
              class="btn btn-icon-only btn-round btn-lg border border-primary" data-toggle="tooltip"
              data-original-title="Follow us">
              <i class="fa fa-linkedin"></i>
            </a>
          </div>
        </div>

        <!-- What We Do -->
        <div class="col-md-4 mt-sm-4 mt-md-0">
          <h5 class="text-white text-uppercase mb-3 footer-title-weight">
            What We Do
          </h5>
          <hr class="hr-line mb-4" />
          <p class="text-white text-uppercase footer-para-weight">
            <router-link class="text-white" to="/our-products">
              Our Products
            </router-link>
          </p>
          <p class="text-white text-uppercase footer-para-weight mt-2 mb-4 pb-4">
            <router-link class="text-white" to="/project-sites">
              Project Sites
            </router-link>
          </p>
        </div>

        <!-- Contact Us -->
        <div class="col-md-4">
          <h5 class="text-white text-uppercase mb-3 footer-title-weight">
            Contact Us
          </h5>
          <hr class="hr-line mb-4" />
          <p class="text-white footer-para-weight mb-4">
            TAWI Compound, Pulo-Diezmo Road, Brgy. Pulo, Cabuyao, Laguna 4025
          </p>
          <p class="text-white footer-para-weight mb-4">
            +{{ sales[2] }} | +{{ sales[1] }} | +{{ sales[0] }}
          </p>
          <p class="text-white footer-para-weight mb-4">support@tawi.com.ph</p>
        </div>
      </div>

      <!-- Logo -->
      <router-link slot="brand" class="navbar-brand" to="/">
        <div class="mb-4">
          <img src="img/brand/optimized/easyhomes-logo-white.svg" style="margin-left: -5px;" alt="logo" />
          <span class="text-white" style="font-size: 20px; vertical-align: middle;">&copy; 2023</span>
        </div>
      </router-link>
    </div>
  </footer>
</template>

<script>
// DAO
import salesDAO from "../database/salesContacts";

export default {
  name: "app-footer",
  data() {
    return {
      year: new Date().getFullYear(),
      sales: [],
    };
  },

  async mounted() {
    // pre-load users
    await this.getAllSales();
  },

  methods: {
    async getAllSales() {
      try {
        this.isLoading = true;
        const salesContact = await salesDAO.retrieveAll();
        this.sales = salesContact.map((sale) => {
          return sale.contactNumber;
        });
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.error(error);
      }
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {
  background-image: url("../../public/img/commons/optimized/footerSection.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom;
  padding: 10px 0 10px 0;
  width: 100%;
  position: relative;
}

.container::after {
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fdb21091;
  z-index: 0;
}

.container-content {
  height: 100%;
  background-color: #fdb210cc;
  padding: 15px 10% 5px 10%;
}

.container>* {
  z-index: 10;
  position: relative;
}

.container-content h3,
.container-content h4 {
  color: #2b2a2a;
  font-weight: 600;
}

.paraContact {
  padding: 0 10% 0 10%;
}

.paragraph,
.contact-us-btn {
  background-color: #dfe0dd;
  width: fit-content;
  border-radius: 10px;
}

.paragraph p {
  font-size: 1.25rem;
  font-weight: 500;
  color: #2b2a2a;
  line-height: 2rem;
  letter-spacing: -0.02rem;
  padding: 20px;
}

.contact-us-btn button {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2b2a2a;
  line-height: 2rem;
  padding: 10px;
  border: none;
  border-radius: 15px;
}

.contact-us-btn button a {
  color: #2b2a2a;
}

.contact-us-btn button a:hover {
  color: #fdb210;
}

.footer {
  padding-top: 0;
  background-color: #000000 !important;
}

.hr-line {
  width: 75%;
  border: 2px solid #fdb210;
}

.footer-title-weight {
  font-weight: 600;
}

.footer-para-weight {
  font-weight: 500;
  font-size: 15px;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .container-content h3 {
    font-size: 1.25rem;
  }

  .container-content h4 {
    font-size: 1rem;
    margin-top: 7%;
  }

  .paraContact {
    padding: 0;
  }

  .paragraph p {
    font-size: 1rem;
  }

  .contact-us-btn p {
    font-size: 1.25rem;
  }
}

/* media queries */

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {}
</style>
